import { render } from "./ClientView.vue?vue&type=template&id=37c96c05"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__